export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";